<template>
  <div class="main-1">
    <section v-if="option == 'start'">
      <v-row class="mt-12">
        <v-col cols="12" md="6">
          <div class="card-start">
            <p class="text-h4 my-4">
              Olá, vou te ajudar a configurar as salas e turmas para a
              simulação.
            </p>
            <p v-if="canKeepSolution" class="text-subtitle-2 mb-6">
              Escolha como você quer começar:
            </p>

            <v-row v-if="canKeepSolution">
              <v-col cols="12" lg="6" class="pb-0">
                <LargeButton
                  type="basic"
                  title="Editar dados e gerar nova simulação"
                  subtitle="Ideal para acrescentar novas turmas ou salas. Você poderá selecionar as alocações desta solução que permanecerão fixas."
                  @click.native="handleStart"
                />
              </v-col>
              <v-col cols="12" lg="6" class="pb-0">
                <LargeButton
                  type="basic"
                  title="Alterar dados e manter solução"
                  subtitle="Ideal para pequenas mudanças. As alterações serão realizadas sem uma nova simulação."
                  @click.native="handleKeepSolution"
                />
              </v-col>
            </v-row>

            <v-expand-transition>
              <div v-if="!canKeepSolution || startChoice" class="mt-6">
                <p v-if="startChoice !== 'keep'" class="text-subtitle-2">
                  Primeiro, nomeie esta nova entrada:
                </p>
                <v-text-field
                  v-if="startChoice !== 'keep'"
                  outlined
                  label="Nome"
                  v-model="nameI"
                  @input="handleChange"
                ></v-text-field>
                <button @click="handleContinue" class="btn blue">
                  {{
                    startChoice === 'keep'
                      ? 'CONTINUAR PARA EDITAR A SOLUÇÃO'
                      : 'CONTINUAR PARA SIMULAÇÃO'
                  }}
                </button>
              </div>
            </v-expand-transition>
          </div>
        </v-col>
        <v-col v-if="!isMobile" cols="12" md="6">
          <div class="mx-auto">
            <v-img
              class="img mt-n12 mb-16"
              src="../../assets/setup-init.svg"
              alt="test"
            />
          </div>
          <ProgressDisplay
            class="mt-5"
            :steps="5"
            :where="1"
            :discription="[
              'Início',
              'Editar Salas',
              'Editar Turmas',
              'Opções',
              'Simular'
            ]"
          />
        </v-col>
      </v-row>
    </section>

    <section v-if="option == 'end'">
      <v-row>
        <v-col cols="12" md="6">
          <div class="card-end grey mt-11 lighten-4">
            <apexchart
              type="pie"
              :options="chartOptions"
              :series="[rooms, classes - preAloc, preAloc]"
            ></apexchart>

            <div
              v-if="!keepSolutionMode"
              @click="saveProgress"
              class="btn-save mt-4"
            >
              <p class="float-left mt-4 ml-6">SALVAR</p>
              <v-icon class="float-right mt-4 mr-6 icon"
                >mdi-content-save-outline</v-icon
              >
            </div>
            <button v-if="!keepSolutionMode" @click="simular" class="btn blue mt-4">
              SIMULAR
            </button>
            <button
              v-else
              :disabled="savingSolution"
              @click="saveSolution"
              class="btn blue mt-4"
            >
              {{ savingSolution ? 'SALVANDO...' : 'SALVAR ALTERAÇÕES' }}
            </button>
          </div>
        </v-col>
        <v-col v-if="!isMobile" cols="12" md="6">
          <div class="mx-auto">
            <v-img
              class="img"
              src="../../assets/Ok-cuate.svg"
              alt="test"
            />
          </div>
          <ProgressDisplay
            :steps="5"
            :where="5"
            :discription="[
              'Início',
              'Editar Salas',
              'Editar Turmas',
              'Opções',
              'Simular'
            ]"
          />
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import ProgressDisplay from "../ProgressDisplay.vue";
import LargeButton from "../LargeButton.vue";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

export default {
  name: "PaasSimuladorDisplay",
  components: {
    ProgressDisplay,
    LargeButton
  },
  props: {
    option: String,
    start: Function,
    startKeepSolution: Function,
    canKeepSolution: Boolean,
    rooms: Number,
    classes: Number,
    preAloc: Number,
    simular: Function,
    saveProgress: Function,
    saveSolution: Function,
    name: String,
    newName: Function,
    keepSolutionMode: Boolean,
    savingSolution: Boolean
  },
  data() {
    return {
      nameI: this.$props.name,
      startChoice: "",
      chartOptions: {
        chart: {
          width: "100%",
          type: "pie"
        },
        labels: [
          "Salas",
          "Turmas Para Alocação",
          "Turmas Pré Alocadas"
        ],
        theme: {
          monochrome: {
            enabled: true
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -5
            }
          }
        },
        dataLabels: {
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, val.toFixed(1) + "%"];
          }
        },
        legend: {
          show: false
        }
      }
    };
  },
  watch: {
    name(newName) {
      this.nameI = newName;
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 570;
    }
  },
  methods: {
    handleChange(e) {
      this.newName(e);
    },
    handleKeepSolution() {
      this.startChoice = "keep";
    },
    handleStart() {
      this.startChoice = "new";
    },
    handleContinue() {
      if (this.startChoice == "keep") {
        this.startKeepSolution();
      } else {
        this.newName(this.nameI);
        this.start();
      }
    }
  }
};
</script>

<style scoped>
.main-1 {
  margin-top: 0;
}

.card-start {
  max-width: 70%;
}

.img {
  max-width: 50%;
  margin: 0 auto 50px auto;
}

.card-end {
  margin: 0 auto 0 auto;
  border-radius: 5px;
  width: 400px;
  padding: 40px;
}

.card-detail {
  border-radius: 5px;
  width: 150px;
  height: 150px;
  text-align: center;
}

.card-detail p {
  margin-top: 20px;
  color: #eeeeee;
  font-size: 30px;
}

.btn {
  color: white;
  width: 100%;
  height: 57px;
  border-radius: 5px;
}

.btn-save {
  cursor: pointer;
  color: white;
  background: linear-gradient(110deg, #64b5f6 75%, white 0%);
  width: 100%;
  height: 57px;
  border-radius: 5px;
}

.icon {
  color: #64b5f6;
}

@media only screen and (max-width: 570px) {
  .card-start {
    max-width: 100%;
    padding: 0 10px;
  }

  .card-end {
    margin-top: 20px;
    width: 100%;
    clear: both;
  }

  .card-detail {
    border-radius: 5px;
    width: 100px;
    height: 100px;
    text-align: center;
  }

  .card-detail p {
    margin-top: 20px;
    color: #eeeeee;
    font-size: 15px;
  }
}
</style>
